import pop from '../assets/categories/pop.svg';
import Folk from '../assets/categories/Bagpipes.svg';
import instrumental from '../assets/categories/Saxophone.svg';
import Rock from '../assets/categories/Guitar.svg';
import Jazz from '../assets/categories/Trumpet.svg';

export const categoriesList = [
  {
    'imgSrc': pop,
    'title': 'Pop',
    'description': 'Duis nec sodales nibh. \nProin lectus tortor, rutrum \nvel vulputate vitae',
    'backgroundColor': 'rgba(219, 132, 29, 0.1)',
  },
  {
    'imgSrc': Folk,
    'title': 'Folk',
    'description': 'Duis nec sodales nibh. \nProin lectus tortor, rutrum \nvel vulputate vitae',
    'backgroundColor': 'rgba(252, 82, 82, 0.1)'
  },
  {
    'imgSrc': instrumental,
    'title': 'Instrumental',
    'description': 'Duis nec sodales nibh. \nProin lectus tortor, rutrum \nvel vulputate vitae',
    'backgroundColor': '#381DDB',
    'color': '#fff'
  },
  {
    'imgSrc': Rock,
    'title': 'Rock',
    'description': 'Duis nec sodales nibh. \nProin lectus tortor, rutrum \nvel vulputate vitae',
    'backgroundColor': 'rgba(192, 0, 150, 0.1)'
  },
  {
    'imgSrc': Jazz,
    'title': 'Jazz',
    'description': 'Duis nec sodales nibh. \nProin lectus tortor, rutrum \nvel vulputate vitae',
    'backgroundColor': 'rgba(132, 196, 255, 0.1)'
  },
];